import React from 'react'
import { BrandPlanIntegrations } from 'types'
import { Check2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { tacticHasGenericIntegration } from '../utils'
import { Account } from 'screens/BrandKit/SourceMaterials/SourceCreationModal/Account'
import { TacticIntegrationDropdown } from '../TacticIntegrationDropdown'
import { TacticIntegrationListVariant } from '../TacticIntegrationList'
import { SwitchPlatformMenu } from '../SwitchPlatformMenu'
import { NoContentInBrandPlan } from './NoContentInBrandPlan'
import Styles from './TacticIntegration.module.scss'
import cx from 'classnames'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

interface ConnectedIntegrationProps {
  integration: ExternalIntegration
  index: number
  variant?: TacticIntegrationListVariant
  tactic?: BrandPlanIntegrations
}

export const ConnectedIntegration: React.FC<ConnectedIntegrationProps> = ({ integration, index, variant, tactic }) => {
  return (
    <div className={cx(Styles.tacticIntegration, Styles.isConnected)}>
      <ResponsiveDesign.Desktop>
        <Text variant="smallList">
          <div className={Styles.indexIndicator}>{index} </div>
        </Text>
      </ResponsiveDesign.Desktop>

      <div className={Styles.tacticName}>
        <Account source={integration} avatarSize={35} />
      </div>

      {variant === 'integrations_page' ? <NoContentInBrandPlan integration={integration} /> : undefined}

      {tacticHasGenericIntegration(tactic) && <SwitchPlatformMenu integration={integration} tactic={tactic} />}

      <div className={Styles.connectedStatus}>
        <div className={Styles.checkIcon}>
          <Check2 size={12} color="var(--light-100)" />
        </div>
        <ResponsiveDesign.Desktop>
          <Text variant="largeList" color="var(--green-50)">
            Connected
          </Text>
        </ResponsiveDesign.Desktop>
      </div>

      <TacticIntegrationDropdown integration={integration} variant={variant} />
    </div>
  )
}
